/**
 * Labstep
 *
 * @module prosemirror/nodes/utils
 * @desc ProseMirror utils methods for nodes
 */

import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import type { TagParseRule } from 'prosemirror-model';

export const getAttrsForId =
  (key: LabstepNode['key']): TagParseRule['getAttrs'] =>
  (node) => {
    if (node instanceof HTMLElement) {
      const attrs: { id?: number | string; guid?: string } = {};

      const id: string | null = node.getAttribute(`data-${key}-id`);
      const idNumber = id && Number(id);
      if (idNumber) {
        attrs.id = idNumber;
      } else if (id) {
        // jupyter_notebook uses string IDs (GUIDs), not numeric IDs
        attrs.id = id;
      }

      const guid: string | null = node.getAttribute(
        `data-${key}-guid`,
      );
      if (guid) {
        attrs.guid = guid;
      }

      return Object.keys(attrs).length ? attrs : false;
    }
    return false;
  };
